<div class="flex justify-between items-center mb-4">
  <h2 class="text-md font-semibold">Clients</h2>
  @if (CanAddClient) {
    <p-button
      type="button"
      label="Add Client"
      icon="pi pi-plus"
      (onClick)="AddClient()"
    ></p-button>
  }
</div>

<div [class.backdrop-blur-sm]="showDialog" class="transition-all duration-300">
  <p-card>
    <div class="flex items-center mb-3 gap-2">
      <p-button
        label="Clear"
        [outlined]="true"
        icon="pi pi-filter-slash"
        (onClick)="clearFilters()"
      />
      <p-selectButton
        [options]="statusOptions"
        [(ngModel)]="statusFilter"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        styleClass="text-sm"
        (onChange)="applyStatusFilter()"
      />
      <p-button
        label="Export"
        [outlined]="true"
        icon="pi pi-file-excel"
        severity="success"
        (onClick)="exportToExcel()"
      />
      <p-iconfield iconPosition="left" class="ml-auto">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input
          pInputText
          type="text"
          [ngModel]="searchTerm"
          (input)="onSearch($any($event.target).value)"
          placeholder="Search Clients"
        />
      </p-iconfield>
    </div>

    <ag-grid-angular
      class="w-full"
      [theme]="theme"
      [style.height.px]="560"
      [columnDefs]="columnDefs"
      [rowData]="clients"
      [defaultColDef]="defaultColDef"
      [animateRows]="false"
      [suppressCellFocus]="true"
      [pagination]="true"
      [paginationPageSize]="10"
      [paginationPageSizeSelector]="[10, 50, 100, 200]"
      [enableBrowserTooltips]="true"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </p-card>
</div>

<p-dialog
  [header]="isEdit ? 'Update Client' : 'Add Client'"
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
>
  <div [formGroup]="clientForm" class="space-y-4">
    <div class="grid grid-cols-2 gap-4 pt-1">
      <p-floatlabel variant="on">
        <input pInputText formControlName="name" id="name" class="w-full" />
        <label for="name" class="required-label">Name</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <input
          pInputText
          formControlName="pocemail"
          id="pocEmail"
          class="w-full"
        />
        <label for="pocEmail">POC Email</label>
      </p-floatlabel>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <p-floatlabel variant="on">
        <input
          pInputText
          formControlName="pocname"
          id="pocName"
          class="w-full"
        />
        <label for="pocName">POC Name</label>
      </p-floatlabel>

      <div class="grid grid-cols-2 gap-4">
        <div class="flex items-center space-x-2">
          <p-checkbox
            formControlName="isActive"
            inputId="isActive"
            binary="true"
          ></p-checkbox>
          <label for="isActive" class="text-sm">Is Active</label>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-4 mt-4">
      <p-button
        type="button"
        severity="secondary"
        label="Cancel"
        (click)="showDialog = false; clientForm.reset(); submitted = false"
      ></p-button>
      <p-button
        type="submit"
        (click)="submit()"
        [label]="isEdit ? 'Update' : 'Add'"
      ></p-button>
    </div>
  </div>
</p-dialog>
<div class="card flex justify-center gap-2">
  <p-confirmDialog
    #cd
    [style]="{ width: '42rem', maxWidth: '95vw' }"
    styleClass="custom-confirm-dialog"
  >
    <ng-template pTemplate="message">
      <div class="space-y-5 px-1">
        <div class="flex items-start gap-4">
          <p class="text-sm text-gray-600 leading-6">
            Are you sure you want to
            <span class="font-semibold text-gray-800">
              {{ selectedAction }}
            </span>
            this client?
          </p>
        </div>

        <div
          *ngIf="
            (popupTableData?.length ?? 0) > 0 && selectedAction === 'deactivate'
          "
          class="space-y-4"
        >
          <div
            class="bg-red-50 border border-red-200 rounded-xl p-4 flex gap-3"
          >
            <i class="pi pi-info-circle text-red-500 mt-1"></i>

            <div>
              <h4 class="text-red-700 font-semibold text-sm mb-1">
                Associated Projects Will Be Deactivated
              </h4>

              <p class="text-sm text-red-600 leading-5">
                Deactivating this client will also deactivate all associated
                projects listed below.
              </p>
            </div>
          </div>

          <h4 class="text-sm font-semibold text-gray-700">
            Associated Projects
          </h4>

          <div class="deactivate-popup-table-wrapper">
            <p-table
              [value]="popupTableData"
              styleClass="p-datatable-sm p-datatable-gridlines"
              [scrollable]="true"
              scrollHeight="220px"
            >
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td *ngFor="let project of row" class="popup-grid-cell">
                    {{ project?.name || '-' }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
  <p-toast></p-toast>
</div>
